import { render, staticRenderFns } from "./ForwardTransaction.vue?vue&type=template&id=61fd4883"
import script from "./ForwardTransaction.vue?vue&type=script&lang=js"
export * from "./ForwardTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports